import React from "react";
import { Controller } from "react-hook-form";
import { useAppSelector } from "@/hooks";

import Input from "@/components/Atoms/Inputs/Input";
import Loader from "@/components/Atoms/Loader";
import ErrorUI from "@/components/Atoms/ErrorUI";

import theme from "@/foundation/Theme";

import { StyledPromoCodeApplyButton } from "./style";
import { InputWrapper, InputGroup } from "../style";

const PromoCodeInput = ({
  name,
  control,
  showLabels,
  promoCodePlaceholder,
  inputFontSize,
  inputLineHeight,
  handlePromoCodeChange,
  promoCodeButtonText,
  applyPromoCode,
  removeAppliedPromoCode,
}) => {
  const {
    promoCodeSuccess: isPromoCodeApplied,
    isPromoCodeLoading: promoCodeChecking,
    promoCodeError,
  } = useAppSelector((state) => state.landingPage);

  return (
    <InputWrapper>
      <InputGroup hasBottomBorder showLabels={showLabels}>
        <Controller
          name={name}
          control={control}
          shouldUnregister
          render={({
            field: { value, onChange, onBlur },
            fieldState: { error, invalid },
          }) => (
            <>
              <Input
                type="text"
                placeholder={promoCodePlaceholder}
                name={name}
                value={value?.toUpperCase()}
                onChange={(e) => {
                  onChange(e);
                  handlePromoCodeChange();
                }}
                onBlur={onBlur}
                autoComplete="off"
                icon={
                  isPromoCodeApplied ? "icon-success-check" : "icon-discount-2"
                }
                inputColor={
                  isPromoCodeApplied
                    ? theme.colorsV2.success.shade_600
                    : theme.colorsV2.gray.shade_800
                }
                iconFill={
                  isPromoCodeApplied
                    ? theme.colorsV2.success.shade_600
                    : theme.colors.black
                }
                iconDimension="20px"
                inputFontSize={inputFontSize || "16px"}
                inputPadding="3px 80px 3px 32px"
                disabled={isPromoCodeApplied}
                variant="v2"
                inputLineHeight={inputLineHeight}
              >
                <StyledPromoCodeApplyButton
                  variant="link"
                  fontSize="13px"
                  TextColor={
                    value.length > 0
                      ? theme.colors.link2Color
                      : theme.colors.quote
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    isPromoCodeApplied
                      ? removeAppliedPromoCode()
                      : applyPromoCode();
                  }}
                  fontFamily="var(--font-700)"
                >
                  {promoCodeButtonText}
                  {promoCodeChecking && (
                    <>
                      &nbsp; <Loader />
                    </>
                  )}
                </StyledPromoCodeApplyButton>
              </Input>
              {(error || promoCodeError) && (
                <ErrorUI
                  marginTop="20px"
                  hasBottomBorder
                  isNotAbsolute
                  error={error?.message || promoCodeError}
                />
              )}
            </>
          )}
        />
      </InputGroup>
    </InputWrapper>
  );
};

export default PromoCodeInput;
